/* Marelle Header - smart-sticky hide-on-scroll.
   Hides the header when scrolling down past 100px, restores on any
   upward scroll. Honors prefers-reduced-motion: if the user prefers
   reduced motion, the header never animates or hides.
   The CSS handles the transform and transition; this JS only toggles
   the .marelle-header--hidden class. */

(function () {
  var header = document.querySelector('[data-sticky-header]');
  if (!header) return;

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  var HIDE_CLASS = 'marelle-header--hidden';
  var THRESHOLD = 100;
  var lastY = window.scrollY;
  var ticking = false;

  function onScroll() {
    var y = window.scrollY;
    if (y > lastY && y > THRESHOLD) {
      header.classList.add(HIDE_CLASS);
    } else if (y < lastY) {
      header.classList.remove(HIDE_CLASS);
    }
    lastY = y;
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        window.requestAnimationFrame(onScroll);
        ticking = true;
      }
    },
    { passive: true }
  );
})();

/* Marelle Header - mobile nav overlay (hamburger + Shop accordion).
   The hamburger button, scrim, and overlay markup exist at every
   viewport width but are display: none above 767px via CSS. This
   controller wires up the interactions unconditionally; on desktop
   the hidden hamburger cannot be clicked so no state changes fire.

   Behaviors:
   - Toggle: hamburger click opens overlay + scrim, sets aria-expanded
     on the hamburger, and locks body scroll while open.
   - Close triggers: close button, scrim click, Escape key, any link
     click inside the overlay marked with [data-nav-close-on-click].
   - Shop accordion: toggle button flips aria-expanded on itself and
     .is-open on its associated sub panel. Closing the overlay also
     resets the Shop accordion to collapsed so re-open starts clean. */

(function () {
  var overlay = document.querySelector('[data-nav-overlay]');
  var scrim = document.querySelector('[data-nav-scrim]');
  var toggle = document.querySelector('[data-nav-toggle]');
  var closeBtn = document.querySelector('[data-nav-close]');

  if (!overlay || !scrim || !toggle) return;

  var shopToggle = overlay.querySelector('[data-nav-shop-toggle]');
  var shopSub = overlay.querySelector('[data-nav-shop-sub]');
  var body = document.body;

  function openNav() {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    scrim.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    body.classList.add('marelle-no-scroll');
  }

  function closeNav() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    scrim.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    body.classList.remove('marelle-no-scroll');
    // Reset Shop accordion so next open starts collapsed.
    if (shopToggle && shopSub) {
      shopToggle.setAttribute('aria-expanded', 'false');
      shopSub.classList.remove('is-open');
    }
  }

  function toggleShop() {
    if (!shopToggle || !shopSub) return;
    var isOpen = shopToggle.getAttribute('aria-expanded') === 'true';
    shopToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    shopSub.classList.toggle('is-open', !isOpen);
  }

  toggle.addEventListener('click', function () {
    var isOpen = overlay.classList.contains('is-open');
    if (isOpen) {
      closeNav();
    } else {
      openNav();
    }
  });

  if (closeBtn) closeBtn.addEventListener('click', closeNav);
  scrim.addEventListener('click', closeNav);

  if (shopToggle) shopToggle.addEventListener('click', toggleShop);

  // Close on any link within the overlay marked to close-on-click
  // (top-level links, sub-list links, featured card).
  overlay.querySelectorAll('[data-nav-close-on-click]').forEach(function (el) {
    el.addEventListener('click', closeNav);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && overlay.classList.contains('is-open')) {
      closeNav();
      toggle.focus();
    }
  });
})();
